<script lang="ts">
import type { SVGAttributes } from 'svelte/elements';

const props: SVGAttributes<SVGElement> = $props();
</script>

<svg
  aria-hidden="true"
  focusable="false"
  fill="none"
  viewBox="0 0 16 16"
  xmlns="http://www.w3.org/2000/svg"
  {...props}
>
  <path
    d="M11.9302 5.19648L10.9288 6.19792C12.5724 7.8416 12.5724 10.4867 10.9288 12.1086C9.28508 13.7523 6.63996 13.7523 5.01805 12.1086C3.37437 10.465 3.37437 7.81983 5.01805 6.19792L7.63052 3.58545L8.00062 3.21535V1.24512L4.06015 5.18559C1.8722 7.37353 1.8722 10.9112 4.06015 13.1101C6.24809 15.3089 9.7858 15.298 11.9411 13.1101C14.129 10.9112 14.129 7.3953 11.9302 5.19648Z"
    fill-rule="evenodd"
    fill="currentColor"
  />
  <path
    d="M10.6967 4.23827C10.7041 3.83556 10.3837 3.50306 9.98103 3.4956C9.57832 3.48814 9.24582 3.80856 9.23836 4.21126C9.2309 4.61397 9.55131 4.94648 9.95402 4.95393C10.3567 4.96139 10.6892 4.64098 10.6967 4.23827Z"
    fill-rule="evenodd"
    fill="currentColor"
  />
</svg>
